/*
 * Copyright (c) 2021. 
 * Md Naimul Hasan 
 * naim886@gmail.com 
 * 01719123886 
 * www.naimbd.com
 */
import React from 'react';
import {Link} from "react-router-dom";

const CreateTruck = () => {
    return (
        <div>
            <main>
                <div className="container-fluid px-4">
                    <h1 className="mt-4">Create Truck</h1>
                    <ol className="breadcrumb mb-5">
                        <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                        <li className="breadcrumb-item"><Link to={'/truck'}>Truck</Link></li>
                        <li className="breadcrumb-item active">Create Truck</li>
                    </ol>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>
                                                    Truck Name
                                                    <input type={'text'} name={'name'} className={'form-control'} placeholder={'Insert Truck Name'}/>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <label>
                                                    Truck Number
                                                    <input type={'text'} name={'truck_number'} className={'form-control'} placeholder={'Truck Number'}/>
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </div>
    );
};

export default CreateTruck;

